import { KeyboardEvent, useState } from 'react';
import { MdAdd, MdClose } from 'react-icons/md';

interface DaysChipsInputProps {
    label: string;
    days: number[];
    onChange: (days: number[]) => void;
    suffix: string;
    disabled?: boolean;
}

const DaysChipsInput = ({ label, days, onChange, suffix, disabled = false }: DaysChipsInputProps) => {
    const [draft, setDraft] = useState('');

    const add = () => {
        const value = Number(draft);
        if (!draft || !Number.isInteger(value) || value <= 0) return;
        onChange(Array.from(new Set([...days, value])).sort((a, b) => b - a));
        setDraft('');
    };

    const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        add();
    };

    return (
        <div>
            {label && <div className="text-xs text-gray-500 uppercase mb-1.5">{label}</div>}
            <div className="flex flex-wrap items-center gap-2">
                {days.map(day => (
                    <span key={day} className="inline-flex items-center gap-1 pl-3 pr-1.5 py-1 rounded-full text-sm bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                        {day} {suffix}
                        <button type="button" disabled={disabled} aria-label={`Remover ${day}`}
                            onClick={() => onChange(days.filter(d => d !== day))}
                            className="p-0.5 rounded-full hover:bg-blue-100 dark:hover:bg-blue-800">
                            <MdClose size={14} />
                        </button>
                    </span>
                ))}
                <span className="inline-flex items-center rounded-full border border-dashed border-gray-300 dark:border-slate-600 pl-3 pr-1 py-0.5">
                    <input value={draft} disabled={disabled} onChange={e => setDraft(e.target.value.replace(/\D/g, ''))}
                        onKeyDown={onKeyDown} placeholder="dias" inputMode="numeric" aria-label={`Adicionar ${label || suffix}`}
                        className="w-12 text-sm bg-transparent focus:outline-none" />
                    <button type="button" onClick={add} disabled={disabled} aria-label="Adicionar"
                        className="p-1 rounded-full text-blue-600 hover:bg-blue-50 dark:hover:bg-slate-700">
                        <MdAdd size={16} />
                    </button>
                </span>
            </div>
        </div>
    );
};

export default DaysChipsInput;
